import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger,
  Checkbox,
  Radio,
} from "react-bootstrap";
import { withRouter } from "react-router";
import { bindActionCreators, compose } from "redux";
import moment from "moment";

import { Breadcrumb as BreadcrumbComponent } from "../../../components";

import { getCoutnryCity } from "../../../redux/actions/emailManagerActions";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import {
  updatesubscribeUser,
  getSubscriberDetail,
} from "../../../redux/actions/frontActions";
import { CSVLink } from "react-csv";
import languageConfig from "../../../config/languageConfig";

let cityID = [];
let csvData = [];
let isLoading = "false";
class UpdateSubscription extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {
      cityList: "",
      cityID: "",
      cityError: false,
      dateError: false,
      allCheck: false,
      zipcode: "",
      firstName: "",
      lastName: "",
      allCity: "no",
      frequency: "",
      show: false,
      alertMessage: "",
      hover: false,
      multi_lang: "no",
      lang: "",
      default_lang: "en",
      path: ["Home", "Update Subscription"],
      links: ["home", "sitelookup"],
      subscriberID: "",
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
  }

  componentWillMount() {
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    if (siteData) {
      this.setState({
        multi_lang: siteData.multi_lang,
        lang: siteData.lang,
        default_lang: siteData.default_lang,
      });
    }
    if (this.props.themeData) {
      if (this.props.themeData.button) {
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
    }
    isLoading = "true";

    if (
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.subscriberID
    ) {
      this.setState({ subscriberID: this.props.match.params.subscriberID });
      this.props.getSubscriberDetail(this.props.match.params.subscriberID);
    }
    this.props.clearAlert();
    this.props.getCoutnryCity();
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.language) {
      this.setState({ default_lang: nextProps.language });
    }

    if (this.props.subscriberDetail != nextProps.subscriberDetail) {
      if (nextProps.subscriberDetail) {
        this.setState({
          allCity: nextProps.subscriberDetail.allcity,
          allCheck: nextProps.subscriberDetail.allcity == "yes" ? true : false,
          cityID: nextProps.subscriberDetail.city,
          frequency: nextProps.subscriberDetail.type,
        });
      }
      cityID = nextProps.subscriberDetail.city;
    }

    if (nextProps.themeData) {
      if (nextProps.themeData.button) {
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
    }
    if (this.props.cityList !== nextProps.cityList) {
      if (nextProps.cityList) {
        isLoading = "false";
        this.setState({ cityList: nextProps.cityList.data });
      }
    }

    if (this.props.subscribeStatus != nextProps.subscribeStatus) {
      if (nextProps.subscribeStatus) {
        isLoading = "false";
        this.handleShow();
        this.props.renderAlert("success", nextProps.subscribeStatus.message);
      }
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType,
      });
      window.scrollTo(0, 0);
    }
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleCityData = (e) => {
    cityID = this.state.cityID ? this.state.cityID : [];
    let index;

    if (e.target.checked) {
      cityID.push(e.target.value);
    } else {
      index = cityID.indexOf(e.target.value);
      cityID.splice(index, 1);
    }
    this.setState({ cityError: false });
    this.setState({ cityID: cityID });
  };

  handleAllCheck = (e) => {
    if (e.target.checked) {
      cityID = [];
      this.state.cityList &&
        this.state.cityID &&
        this.state.cityList.map((data, index) =>
          data.cities.map((cityData, index) => cityID.push(cityData.cityID))
        );
      this.setState({
        allCheck: true,
        allCity: "yes",
        cityError: false,
        cityID: cityID,
      });
    } else {
      cityID = [];
      this.setState({ allCheck: false, allCity: "no", cityID: cityID });
    }
  };

  validate = (e) => {
    let isError = false;
    if (this.state.cityID.length == 0 && this.state.allCity == "no") {
      isError = true;
      this.setState({ cityError: true });
    } else {
      this.setState({ cityError: false });
    }

    return isError;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    let isError = this.validate();
    // let referredBy = cookies.get("referredBy");
    if (!isError) {
      const constData = {
        subscriberID: this.state.subscriberID,
        all_city: this.state.allCity,
        city: this.state.allCity == "no" ? this.state.cityID : [],
        frequency: this.state.frequency,
        unsubscribe: "no",
      };
      isLoading = "true";
      this.props.updatesubscribeUser(constData);
    }
  };

  validateEmail = (e) => {
    let isError = false;

    return isError;
  };

  handleSubscribe = (e) => {
    e.preventDefault();
    let isError = this.validateEmail();
    if (!isError) {
      const constData = {
        subscriberID: this.state.subscriberID,
        unsubscribe: "yes",
        frequency: this.state.frequency,
        all_city: this.state.allCity,
        city: this.state.allCity == "no" ? this.state.cityID : [],
      };
      isLoading = "true";
      this.props.updatesubscribeUser(constData);
    }
  };

  render() {
    return (
      <div className="container">
        <div className="col-lg-12 add-sub-admin">
          {isLoading == "true" ? (
            <div className="loader">
              <p className="loading-message">
                <i>Loading...</i>
              </p>
              <div className="spinner">
                <div className="dot1" />
                <div className="dot2" />
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent
                path={this.state.path}
                links={this.state.links}
                context={this.context}
              />
            </div>
          </div>
          <form>
            <div className="panel">
              <header className="panel-heading">
                {languageConfig[this.state.default_lang].manage_subscripton}
              </header>
              {this.state.show && this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}
              <div className="panel-body">
                <Row>
                  <Col md={12} xs={12}>
                    <FormGroup>
                      <Row>
                        <Col md={12} xs={12}>
                          <ControlLabel>
                            {languageConfig[this.state.default_lang].cities}:{" "}
                            <span className="text-danger">
                              {this.state.cityError
                                ? "(Please select city.)"
                                : ""}
                            </span>
                          </ControlLabel>
                        </Col>
                        <Col md={12} xs={12}>
                          {this.state.allCity == "yes" ? (
                            <Checkbox
                              value="all"
                              defaultChecked={true}
                              onClick={this.handleAllCheck}
                            >
                              {
                                languageConfig[this.state.default_lang]
                                  .select_all_city
                              }
                            </Checkbox>
                          ) : (
                            <Checkbox value="all" onClick={this.handleAllCheck}>
                              {
                                languageConfig[this.state.default_lang]
                                  .select_all_city
                              }
                            </Checkbox>
                          )}
                        </Col>
                      </Row>
                      {this.state.cityList &&
                        this.state.cityID &&
                        this.state.cityList.map((data, index) => (
                          <Row>
                            <Col md={12} xs={12}>
                              <b>
                                {data.cities.length != 0 ? data.country : ""}
                              </b>
                            </Col>
                            <Col md={12} xs={12}>
                              <Row>
                                {data.cities.map((cityData, index) => (
                                  <Col md={4} xs={12}>
                                    {this.state.cityID.indexOf(
                                      JSON.stringify(cityData.cityID)
                                    ) > -1 ? (
                                      // <div>check</div>
                                      <Checkbox
                                        onClick={this.handleCityData}
                                        defaultChecked={true}
                                        value={cityData.cityID}
                                      >
                                        {cityData.title}
                                      </Checkbox>
                                    ) : (
                                      <Checkbox
                                        onClick={this.handleCityData}
                                        checked={this.state.allCheck}
                                        value={cityData.cityID}
                                      >
                                        {cityData.title}
                                      </Checkbox>
                                    )}
                                  </Col>
                                ))}
                              </Row>
                            </Col>
                          </Row>
                        ))}
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={12} xs={12}>
                    <ControlLabel>
                      {languageConfig[this.state.default_lang].choose_preferred}
                      :{" "}
                    </ControlLabel>
                  </Col>
                  <Col md={12} xs={12}>
                    {this.state.frequency == "DAILY" ? (
                      <Radio
                        name="frequency"
                        defaultChecked={true}
                        value="DAILY"
                      >
                        {languageConfig[this.state.default_lang].daily}
                      </Radio>
                    ) : (
                      <Radio
                        name="frequency"
                        onClick={this.handleChange}
                        value="DAILY"
                      >
                        {languageConfig[this.state.default_lang].daily}
                      </Radio>
                    )}
                  </Col>
                  <Col md={12} xs={12}>
                    {this.state.frequency == "WEEKLY" ? (
                      <Radio
                        name="frequency"
                        defaultChecked={true}
                        value="WEEKLY"
                      >
                        {languageConfig[this.state.default_lang].weekly}
                      </Radio>
                    ) : (
                      <Radio
                        name="frequency"
                        onClick={this.handleChange}
                        value="WEEKLY"
                      >
                        {languageConfig[this.state.default_lang].weekly}
                      </Radio>
                    )}
                  </Col>
                  <Col md={12} xs={12}>
                    {this.state.frequency == "TWICEINMONTH" ? (
                      <Radio
                        name="frequency"
                        defaultChecked={true}
                        value="TWICEINMONTH"
                      >
                        {languageConfig[this.state.default_lang].twice_month}
                      </Radio>
                    ) : (
                      <Radio
                        name="frequency"
                        onClick={this.handleChange}
                        value="TWICEINMONTH"
                      >
                        {languageConfig[this.state.default_lang].twice_month}
                      </Radio>
                    )}
                  </Col>
                </Row>

                <Row>
                  <hr />
                </Row>
                <Row>
                  <Col md={12} xs={12}>
                    <Button
                      type="submit"
                      bsStyle="success"
                      onClick={this.handleSubmit}
                      style={{
                        backgroundColor:
                          this.state.hover && this.state.hoverID == "Subscribe"
                            ? this.state.mouseover_color
                            : this.state.button_color
                            ? this.state.button_color
                            : "#77C84E",
                      }}
                      data-id={"Subscribe"}
                    >
                      {languageConfig[this.state.default_lang].subscribe}
                    </Button>
                    <Button
                      type="submit"
                      bsStyle="danger"
                      onClick={this.handleSubscribe}
                      style={{
                        backgroundColor:
                          this.state.hover &&
                          this.state.hoverID == "unsubscriber"
                            ? this.state.mouseover_color
                            : this.state.button_color,
                      }}
                      data-id={"unsubscriber"}
                    >
                      {languageConfig[this.state.default_lang].unsubscribe}
                    </Button>
                    <a
                      className="btn btn-default"
                      onClick={() =>
                        this.context.router.history.push(`/sitelookup`)
                      }
                    >
                      {languageConfig[this.state.default_lang].cancel}
                    </a>
                  </Col>
                </Row>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    subscribeStatus: state.frontReducer.subscribeStatus,
    error: state.frontReducer.error,
    cityList: state.emailManagerReducer.cityList,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    subscriberDetail: state.frontReducer.subscriberDetail,
  };
};
export default compose(
  withRouter,
  connect(mapStateToProps, {
    getCoutnryCity,
    updatesubscribeUser,
    renderAlert,
    clearAlert,
    getSubscriberDetail,
  })
)(UpdateSubscription);



// WEBPACK FOOTER //
// ./src/app/views/admin/generalSearch/UpdateSubscription.js